import _asyncToGenerator from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import { Message, MessageBox } from 'element-ui';
import utils from '@/utils';
import router from '@/router';
export default (function (context) {
  return {
    namespaced: true,
    state: {
      // 用户登录状态
      isLogged: !!utils.cookies.get('token'),
      // 用户信息
      info: {}
    },
    getters: {
      name: function name(state) {
        return utils.fn.getFromMulti(state.info, ['nickname', 'userName'], '');
      }
    },
    actions: {
      /**
       * @description 登录
       * @param {Object} vuex context
       * @param {Object} payload username {String} 用户账号
       * @param {Object} payload password {String} 密码
       * @param {Object} payload route {Object} 登录成功后定向的路由对象 任何 vue-router 支持的格式
       */
      login: function login(_ref) {
        var _arguments = arguments;
        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var commit, dispatch, _ref2, _ref2$username, username, _ref2$password, password, _ref2$to, to, data;

          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  commit = _ref.commit, dispatch = _ref.dispatch;
                  _ref2 = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {}, _ref2$username = _ref2.username, username = _ref2$username === void 0 ? '' : _ref2$username, _ref2$password = _ref2.password, password = _ref2$password === void 0 ? '' : _ref2$password, _ref2$to = _ref2.to, to = _ref2$to === void 0 ? '/' : _ref2$to;
                  _context.prev = 2;
                  _context.next = 5;
                  return context.api.USER_LOGIN({
                    username: username,
                    password: password
                  });

                case 5:
                  data = _context.sent;
                  // 设置 cookie 一定要存 uuid 和 token 两个 cookie
                  // 整个系统依赖这两个数据进行校验和存储
                  // uuid 是用户身份唯一标识 用户注册的时候确定 并且不可改变 不可重复
                  // token 代表用户当前登录状态 建议在网络请求中携带 token
                  // 如有必要 token 需要定时更新，默认保存一天
                  utils.cookies.set('uuid', data.userId);
                  utils.cookies.set('token', data.token);
                  utils.cookies.set('phone', data.phone);
                  utils.cookies.set('market_id', data.market_id);
                  utils.cookies.set('time_zone', data.time_zone); // 设置用户已经登陆

                  commit('isLoggedSet', true); // 设置 vuex 用户信息

                  _context.next = 14;
                  return dispatch('d2admin/user/set', data, {
                    root: true
                  });

                case 14:
                  _context.next = 16;
                  return dispatch('d2admin/permission/load', {
                    focus: true,
                    to: to
                  }, {
                    root: true
                  });

                case 16:
                  _context.next = 18;
                  return dispatch('d2admin/sys/load', undefined, {
                    root: true
                  });

                case 18:
                  // 显示提示信息
                  Message({
                    message: 'login success',
                    type: 'success'
                  }); // 结束

                  return _context.abrupt("return", Promise.resolve());

                case 22:
                  _context.prev = 22;
                  _context.t0 = _context["catch"](2);
                  return _context.abrupt("return", Promise.reject(_context.t0));

                case 25:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[2, 22]]);
        }))();
      },

      /**
       * @description 注销用户并返回登录页面
       * @param {Object} vuex context
       * @param {Object} payload focus {Boolean} 强制登出 没有任何提示
       * @param {Object} payload remote {Boolean} 需要服务端登出
       * @param {Object} payload back {Boolean} 返回当前页面
       */
      logout: function logout(_ref3) {
        var commit = _ref3.commit,
            dispatch = _ref3.dispatch;

        var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref4$focus = _ref4.focus,
            focus = _ref4$focus === void 0 ? false : _ref4$focus,
            _ref4$remote = _ref4.remote,
            remote = _ref4$remote === void 0 ? true : _ref4$remote,
            _ref4$back = _ref4.back,
            back = _ref4$back === void 0 ? false : _ref4$back;

        /**
         * @description 注销
         */
        function logout() {
          return _logout.apply(this, arguments);
        } // 判断是否需要确认


        function _logout() {
          _logout = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            var redirect;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    // 设置用户登陆状态
                    commit('isLoggedSet', false); // 请求登出接口 不管成功与否都要进行下一步，所以不用 await 了

                    if (remote) context.api.USER_LOGOUT(); // 删除 cookie

                    utils.cookies.remove('token');
                    utils.cookies.remove('uuid'); // 本地清空用户信息

                    _context2.next = 6;
                    return dispatch('d2admin/user/set', {}, {
                      root: true
                    });

                  case 6:
                    // 计算跳转的路由
                    redirect = '';

                    if (back) {
                      if (['login'].indexOf(router.app.$route.name) < 0) redirect = router.app.$route.fullPath;else redirect = router.app.$route.query.redirect;
                    } // 重置权限并且跳转到登录页 通过 back 参数指定在登陆之后是否需要跳转回原来的页面


                    _context2.next = 10;
                    return dispatch('d2admin/permission/load', {
                      focus: true,
                      to: {
                        name: 'login',
                        query: redirect ? {
                          redirect: redirect
                        } : {}
                      },
                      data: []
                    }, {
                      root: true
                    });

                  case 10:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));
          return _logout.apply(this, arguments);
        }

        if (!focus) {
          commit('d2admin/gray/set', true, {
            root: true
          });
          MessageBox.confirm('confirm logout current user?', 'logout user', {
            type: 'warning'
          }).then(function () {
            commit('d2admin/gray/set', false, {
              root: true
            });
            logout();
          }).catch(function () {
            commit('d2admin/gray/set', false, {
              root: true
            });
            Message({
              message: 'cancal logout'
            });
          });
        } else {
          logout();
        }
      },

      /**
       * @description 设置用户数据
       * @param {Object} vuex context
       * @param {*} info info
       */
      set: function set(_ref5, info) {
        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
          var state, dispatch;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  state = _ref5.state, dispatch = _ref5.dispatch;
                  // store 赋值
                  state.info = info; // 持久化

                  _context3.next = 4;
                  return dispatch('d2admin/db/set', {
                    dbName: 'sys',
                    path: 'user.info',
                    value: info,
                    user: true
                  }, {
                    root: true
                  });

                case 4:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }))();
      },

      /**
       * @description 从数据库取用户数据
       * @param {Object} vuex context
       */
      load: function load(_ref6) {
        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
          var state, dispatch;
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  state = _ref6.state, dispatch = _ref6.dispatch;
                  _context4.next = 3;
                  return dispatch('d2admin/db/get', {
                    dbName: 'sys',
                    path: 'user.info',
                    defaultValue: {},
                    user: true
                  }, {
                    root: true
                  });

                case 3:
                  state.info = _context4.sent;

                case 4:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }))();
      }
    },
    mutations: {
      /**
       * @description 设置用户登陆状态
       * @param {Object} state state
       * @param {Boolean} value 是否登录
       */
      isLoggedSet: function isLoggedSet(state, value) {
        state.isLogged = value;
      }
    }
  };
});